import axios from 'axios';
import config from '../../config';
import { getAxiosConfigUserToken } from '../../util/utilFunction';

export const getProjectAllApi = async()=>{
    const url = `${config.apiUrl}/v1/project/`;
    return await axios.get(url,getAxiosConfigUserToken())
    .then(response => response.data)
 }

 export const postSaveProjectApi = (project)=>{
    const url = `${config.apiUrl}/v1/project/`;
    return axios.post(url,project,getAxiosConfigUserToken())
    .then(response => response.data);
 } 
 export const putUpdateProjectApi = (project)=>{
   const url = `${config.apiUrl}/v1/project/`;
   return axios.put(url,project,getAxiosConfigUserToken())
   .then(response => response.data);
}
 export const deletetProjectByIdApi = async(id)=>{
   const url = `${config.apiUrl}/v1/project/${id}`;
   return await axios.delete(url,getAxiosConfigUserToken())
   .then(response => response.data)
}
export const getProjectCategoryByIdApi = async (id)=>{
   const url = `${config.apiUrl}/v1/project/category/${id}`;
   return await axios.get(url,getAxiosConfigUserToken())
   .then(response => response.data) 
}

export const postSaveProjectCategoryApi = (projectCategory)=>{
   const url = `${config.apiUrl}/v1/project/category/`;
   return axios.post(url,projectCategory,getAxiosConfigUserToken())
   .then(response => response.data);
} 

export const deleteProjectCategoryByIdApi = async(id)=>{
   const url = `${config.apiUrl}/v1/project/category/${id}`;
   return await axios.delete(url,getAxiosConfigUserToken())
   .then(response => response.data)
}
export const getProjectColumnByIdApi = async (id)=>{
   const url = `${config.apiUrl}/v1/project/projectColumn/${id}`;
   return await axios.get(url,getAxiosConfigUserToken())
   .then(response => response.data) 
}

export const postSaveProjectColumnApi = async(projectColumn)=>{
   const url = `${config.apiUrl}/v1/project/projectColumn/`;
   return axios.post(url,projectColumn,getAxiosConfigUserToken())
   .then(response => response.data);
} 
export const postSaveProjectTableCreateApi = async(project)=>{
   const url = `${config.apiUrl}/v1/project/projectColumn/tableCreate/`;
   return axios.post(url,project,getAxiosConfigUserToken())
   .then(response => response.data);
} 

export const deleteProjectColumnByIdApi = async(id)=>{
   const url = `${config.apiUrl}/v1/project/projectColumn/${id}`;
   return await axios.delete(url,getAxiosConfigUserToken())
   .then(response => response.data)
}
export const getProjectByIdApi = async (id)=>{
   const url = `${config.apiUrl}/v1/project/${id}`;
   return await axios.get(url,getAxiosConfigUserToken())
   .then(response => response.data)
}
export const getProjectByProjectIdApi = async(projectId)=>{
    const url = `${config.apiUrl}/v1/project/byProjectId/${projectId}`;
    return await axios.get(url,getAxiosConfigUserToken())
    .then(response => response.data)
 }
 export const getProjectByInstApi = async(inst)=>{
     const url = `${config.apiUrl}/v1/project/byInst/${inst}`;
     return await axios.get(url,getAxiosConfigUserToken())
     .then(response => response.data)
  }
  export const getProjectAddedArticlePDFByIdApi = (id)=>{
    const url = `${config.apiUrl}/v1/pdf/projectAddedArticleList/${id}`;
    return axios.get(url,{
       method: 'GET',
       responseType: 'blob',
       ...getAxiosConfigUserToken()
    })
    .then(response => {
       const file = new Blob(
          [response.data], 
          {type: 'application/pdf'});
          return file;
    });
 }


export const postUploadProjectLogoApi = async(formData,onUploadProgress)=>{
             try{
             const url = `${config.apiUrl}/v1/project/uploadLogo/`; 
             return await axios.post(url,formData,{
                     
                         headers:{
                             'Content-Type':'multipart/form-data',
                             ...getAxiosConfigUserToken().headers,
                         },
                         
                         onUploadProgress
                 }).then(response => response.data) 
 
             } catch (err) {
                 if(err.response.status ===500){
                     return {status:false , errorMessage:"Sunucu problemi var" }
                 }
                 else{
                     return {status:false , errorMessage:err.response.data.msg }
                 }
             }
 }

 export const postUploadProjectPrincipleFileApi = async(formData,onUploadProgress)=>{
             try{
             const url = `${config.apiUrl}/v1/project/uploadPrinciple/`; 
             return await axios.post(url,formData,{
                     
                         headers:{
                             'Content-Type':'multipart/form-data',
                             ...getAxiosConfigUserToken().headers,
                         },
                         
                         onUploadProgress
                 }).then(response => response.data) 
 
             } catch (err) {
                 if(err.response.status ===500){
                     return {status:false , errorMessage:"Sunucu problemi var" }
                 }
                 else{
                     return {status:false , errorMessage:err.response.data.msg }
                 }
             }
 }

 
 export const postTransferGateProjectApi = (project)=>{
    const url = `${config.apiUrl}/v1/project/transferGate/`;
    return axios.post(url,project,getAxiosConfigUserToken())
    .then(response => response.data);
 } 